import React from "react";

import { Link, Typography } from "@mui/material";

export const InfoDialogBody = () => {
  return (
    <>
      <Typography variant="body1" paragraph>
        London is outgrowing its drains and sewers. The combined sewer system
        originally built over 150 years ago by Joseph Bazalgette has served us
        well, but it was designed for a smaller city with more green surfaces.
        The combined challenges of London’s growing population, changing land
        uses and changing climate mean that if we continue to rely on our
        current drains and sewers, we face an increasing risk of flooding.
      </Typography>
      <Typography variant="body1" paragraph>
        To make the most effective use of our existing and planned drainage
        infrastructure and avoid increased flood risk, we need to change how
        London’s drainage system operates. Rainwater should be managed as a
        valuable resource rather than a waste product. We need to roll back the
        tide of impermeable surfaces. They should be replaced with ‘sustainable
        drainage’ systems that mimic the ways that nature manages rainwater and
        add to the services provided by our existing drains and sewers. The need
        for more sustainable drainage is now widely recognised internationally
        and embedded in our national and local planning systems including in the
        Mayor’s London Plan.
      </Typography>
      <Typography variant="body1" paragraph>
        This map shows the good work done by Boroughs, TfL, housing
        associations, water companies, charities and others to install SuDS
        across London. The map will be updated regularly by these organisations
        as more SuDS are delivered.
      </Typography>
      <Typography variant="body1" paragraph>
        Please note, not all points are comparable. For example, there may be
        one point representing multiple rain gardens along a street in one
        Borough, whereas in another Borough there is a separate point of each
        rain garden in the street.
      </Typography>
      <Typography variant="body1" paragraph>
        For more information about sustainable drainage please visit the{" "}
        <Link
          target="_blank"
          rel="noreferrer"
          href="https://www.london.gov.uk/what-we-do/environment/climate-change/surface-water/sustainable-drainage-london#acc-i-44929"
          underline="hover"
        >
          GLA website
        </Link>
        .
      </Typography>
      <Typography variant="body1" paragraph>
        <Link
          target="_blank"
          rel="noreferrer"
          href="https://www.london.gov.uk/what-we-do/environment/climate-change/surface-water/suds-sector-guidance"
          underline="hover"
        >
          Sector-specific sustainable drainage guidance{" "}
        </Link>
        has been developed to enable sectors to implement SuDS on their estate.
        There is guidance for schools, social housing, hospitals, commercial and
        retail.
      </Typography>
    </>
  );
};

export const infoDialogTitle = "About This Map";
